"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  maxSize: 10 * 1024 * 1024,
  // 10MB of bytes for filesize limits
  customText: 'https://s3.amazonaws.com/scoir_static/assets/js/scoir_fp_en.json'
};
exports.default = _default;